import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Features from "@/components/Features";
import Sectors from "@/components/Sectors";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import BackToTop from "@/components/BackToTop";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1.0 });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain min-h-screen bg-[#0b0c10]" data-testid="app-root">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Features />
        <Sectors />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#171923",
            border: "1px solid rgba(245,158,11,0.35)",
            color: "#f9fafb",
          },
        }}
      />
    </div>
  );
}
